export default {
      id: "second-passphrase-usage",
      viewBox: "0 0 448 512",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#second-passphrase",
      toString: function () {
        return this.url;
      }
    }